import Typography from '@mui/material/Typography';

type TablePageTitleProps = {
  children: string;
};

export const TablePageTitle = ({ children }: TablePageTitleProps) => {
  return <Typography variant="h2">{children}</Typography>;
};
